<template>
  <Main>
    <BaseTab :value="currentTab" @change="currentTab = $event">
      <v-tab>Grupo Econômico</v-tab>
      <v-tab-item class="py-5">
        <EconomicGroupTab :can-create="canCreateEconomicGroup">
          <template v-slot:filter>
            <BaseFilter
              v-model="search"
              v-bind="filterProps"
              textPlaceholder="Buscar"
              @search="searchByFilter"
              v-on:keyup="searchByFilterClickEnter"
            />
          </template>
          <BaseDataTable
            :headers="tableHeaders"
            :items="economicGroups.items"
            :server-items-length="economicGroups.total_count"
            no-data-text="Não há Grupos Econômicos cadastrados."
            loading-text="Carregando groups econômicos..."
            :options.sync="filterOptions"
            :loading="listLoading"
            class="eg-table"
            @click:row="listCompanies"
          >
            <template v-slot:[`item.referencia`]="{ item }">
              <div :class="borderColor(item.status.id)">
                {{ item.referencia }}
              </div>
            </template>
            <template v-slot:[`item.ativo`]="{ item }">
              {{ item.status.nome }}
            </template>
          </BaseDataTable>
        </EconomicGroupTab>
      </v-tab-item>
      <v-tab>Acompanhar Seguradoras</v-tab>
      <v-tab-item class="py-5">
        <AccompanyInsurersTable />
      </v-tab-item>
    </BaseTab>
  </Main>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import {
  CommonPayload as ResourceFilterMixin,
  defaultFilterOptions
} from "@/mixins/PayloadDataTableMixin";
import EconomicGroupTab from "../components/EconomicGroupTab.vue";
import AccompanyInsurersTable from "../components/AccompanyInsurersTable";
const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};

const tableHeaders = [
  { text: "Referência", value: "referencia", sortable: true },
  { text: "Nome", value: "nome", sortable: true },
  { text: "Status", value: "ativo", sortable: true }
];

const colorByStatus = {
  ativo: { color: "blue" }
};

const DEFAULT_STATUS_COLOR = { color: "yellow" };

export default {
  name: "EconomicGroupList",
  mixins: [LoadingRequest, ResourceFilterMixin],
  components: { EconomicGroupTab, AccompanyInsurersTable },
  data: () => ({
    currentTab: 0,
    listLoading: false,
    search: "",
    tableHeaders,
    filterProps: defaultFilterProps,
    filterOptions: defaultFilterOptions()
  }),
  computed: {
    ...mapState("economic_group", ["economicGroups"]),
    ...mapState(["userPermissions"]),
    canCreateEconomicGroup() {
      return this.userPermissions.acoes.some(
        x => x.id == "criar_grupo_economico"
      );
    },
    canEditEconomicGroup() {
      return this.userPermissions.acoes.some(
        x => x.id == "editar_grupo_economico"
      );
    }
  },
  methods: {
    ...mapActions("economic_group", [
      "listEconomicGroups",
      "selectEconomicGroup"
    ]),
    ...mapActions(["showAlertNotification"]),
    borderColor(status) {
      const { color } = colorByStatus[status] || DEFAULT_STATUS_COLOR;
      return `eg-table__border eg-table__border-${color}`;
    },
    listCompanies(item) {
      if (!this.canEditEconomicGroup)
        this.showAlertNotification({
          message: "Usuário sem permissão para acessar a página",
          type: "error"
        });
      this.selectEconomicGroup(item);
      this.$router.push({
        name: "economic_group view",
        params: { groupId: item.id }
      });
    },
    performFilter(filter) {
      this.withLoading(this.listEconomicGroups(filter));
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13) this.searchByFilter();
    },
    searchByFilter() {
      this.performFilter(this.toLSPFilter(this.filterOptions, this.search));
    }
  },
  watch: {
    filterOptions: {
      handler(value) {
        this.performFilter(this.toLSPFilter(value, this.search));
      },
      deep: true
    }
  }
};
</script>

<style lang="sass">
.eg-table
  .v-data-table__wrapper
    @media (min-width:960px)
      overflow: visible !important
  td
    position: relative
  &__border::before
    overflow: visible !important
    display: block
    position: absolute
    background-color: #CCC
    width: 5px
    border-radius: 2px
    top: 8px
    bottom: 8px
    left: 0px
    margin-left: -3px
    content: " "
  &__border-blue::before
    background-color: var(--v-secondary-base) !important
  &__border-yellow::before
    background-color: var(--v-yellow-base) !important
</style>
